<div class="catalog-page">
  <h1 class="catalog-title">{{ 'catalog.title' | translate }}</h1>
  <p class="catalog-lede">{{ 'catalog.lede' | translate }}</p>

  @if (loading()) {
    <div class="catalog-state">{{ 'catalog.loading' | translate }}</div>
  } @else if (error()) {
    <div class="catalog-state error">{{ 'catalog.error' | translate }}</div>
  } @else if (categories().length === 0) {
    <div class="catalog-state">{{ 'catalog.empty' | translate }}</div>
  } @else {
    @for (category of categories(); track category.id) {
      <section class="catalog-category">
        <h2 class="catalog-category-title">
          <span class="catalog-category-num">{{ category.num }}</span> {{ category.title }}
        </h2>

        <div class="catalog-grid">
          @for (course of category.courses; track course.program_id) {
            <article class="course-card" [class.is-bundle]="course.is_bundle"
                     (click)="openCourse(course)" tabindex="0" (keyup.enter)="openCourse(course)">
              <div class="course-thumb">
                @if (course.thumbnail_url) {
                  <img [src]="course.thumbnail_url | serverAuthUrl" [alt]="course.title" loading="lazy" />
                } @else if (course.is_bundle) {
                  <div class="bundle-thumb">
                    <span class="bundle-thumb-price">{{ course.price | currency: course.currency }}</span>
                  </div>
                }
                <span class="course-badge"
                      [class.is-free]="course.free"
                      [class.is-owned]="course.owned"
                      [class.is-bundle]="course.is_bundle && !course.owned">
                  @if (course.owned) {
                    {{ 'catalog.badge.owned' | translate }}
                  } @else if (course.free) {
                    {{ 'catalog.badge.free' | translate }}
                  } @else if (course.is_bundle) {
                    {{ 'catalog.badge.bundle' | translate }}
                  } @else {
                    {{ course.price | currency: course.currency }}
                  }
                </span>
              </div>
              <div class="course-body">
                <h3 class="course-name">{{ course.title }}</h3>
                @if (course.subtitle) {
                  <p class="course-subtitle">{{ course.subtitle }}</p>
                }
                @if (course.is_bundle && course.members?.length) {
                  <p class="course-members">{{ course.members!.join(' · ') }}</p>
                }
                <span class="course-cta">
                  @if (!course.is_bundle && course.accessible) {
                    {{ 'catalog.action.open' | translate }} →
                  } @else {
                    {{ 'catalog.action.details' | translate }} →
                  }
                </span>
              </div>
            </article>
          }
        </div>
      </section>
    }
  }
</div>
